/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { useContext } from 'preact/hooks';
import { EnvironmentContext } from '../../UNSAFE_Environment';
import type { TranslationBundle } from '../../UNSAFE_Environment';

/**
 * useTranslationBundle is a hook to get a translation bundle from the EnvironmentProvider
 * @param bundleId
 * @returns a translation bundle of type T
 */
export function useTranslationBundle<T extends TranslationBundle>(bundleId: string) {
  const translations = useContext(EnvironmentContext).translations;
  const bundle = translations?.[bundleId];
  if (!bundle) {
    throw new Error(`Translation bundle ${bundleId} is not loaded.`);
  }
  return bundle as T;
}
